/**
 * This file contains extensions and mime types that we support for each element of the app
 */

export const audioExtensions = [
  '.mp3',
  '.wav'
]

export const audioMimeTypes = [
  'audio/mpeg',

  // WAV has so many different MIME types...
  'audio/x-wav',
  'audio/vnd.wave',
  'audio/wav',
  'audio/wave',
  'audio/x-pn-wav'
]

export const audioAccept = [...audioExtensions, ...audioMimeTypes]

export const backgroundExtensions = [
  '.mp4',
  '.gif',
  '.jpg',
  '.jpeg',
  '.png',
  '.mov'
]

export const backgroundMimeTypes = [
  'video/mp4',
  'image/gif',
  'image/jpeg',
  'image/png',
  'video/mov'
]

export const backgroundBinaryFileTypes = [
  '00014', //mov
  '00020', //mp4
  '47494638', //gif
  'FFD8FFDB', // jpeg
  'FFD8FFE0', // jpeg
  'FFD8FFE1', // jpeg
  '89504E47' //png
]

export const acceptedVideoCodecs = [
  'av01', // mp4 mkv webm
  'avc1', // mp4 mov m4v mkv
  'avc3', // mp4 mov m4v mkv
  'hev1', //mp4 mov m4v mkv
  'hvc1', //mp4 mov m4v mkv
  'vp8', // webm mkv
  'vp09' // webm mkv
]

export const backgroundAccept = [...backgroundExtensions, ...backgroundMimeTypes]

export const logoExtensions = [
  '.gif',
  '.jpg',
  '.jpeg',
  '.png'
]

export const logoMimeTypes = [
  'image/gif',
  'image/jpeg',
  'image/png'
]

export const audioExtensionByMimeType: {[key: string]: string} = {
  'audio/mpeg': 'mp3',

  // WAV has so many different MIME types...
  'audio/x-wav': 'wav',
  'audio/vnd.wave': 'wav',
  'audio/wav': 'wav',
  'audio/wave': 'wav',
  'audio/x-pn-wav': 'wav'
}

export const logoAccept = [...logoExtensions, ...logoMimeTypes]
